<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">Entrance Test Result</h4>
                    <div class="card-body text-justify">
                        <div class="alert alert-info alert-dismissible" role="alert">
                           Please Write Date Of Birth in DD/MMM/YYYY Format. Example 03/Apr/1998!
                           <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                          </div>
                        <div class="alert alert-warning alert-danger fade show" role="alert" *ngIf="alert">
                           {{message}}
                           <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                          </div>
                        <form class="form-inline" #searchForm="ngForm" (ngSubmit)="onSubmit(searchForm)">
        
                            <div class="form-group mx-sm-3 mb-2">
                                <input type="text" class="form-control" id="search"
                                name="search"
                                ngModel
                                required
                                 placeholder="Enter Application Number"
                                 style="width: 210px;">
                            </div>
                            <div class="form-group mx-sm-3 mb-2">
                                <input type="text" class="form-control" id="dob"
                                name="dob"
                                ngModel
                                required
                                 placeholder="Enter Date Of Birth in DD/MMM/YYYY"
                                 style="width: 260px;">
                            </div>
                              <button type="submit" class="btn btn-primary mb-2" [disabled]="searchForm.invalid">Search</button>
                        </form>
                        <div class="row detail mt-5">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Student Name</th>
                                    <th scope="col">Father's Name</th>
                                    <th scope="col">Class</th>
                                    <th scope="col">Branch</th>
                                    <th scope="col">Result Remark</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="row">{{data.student}}</th>
                                    <td>{{data.father}}</td>
                                    <td>{{data.course}}</td>
                                    <td>{{data.branch}}</td>
                                    <td class="text-center" >
                                        <p [ngClass]="data.remarks === 'NOT QUALIFIED' ? 'notQualified' : ((data.remarks != 'WAITING' && data.remarks != 'ABSENT') ? 'qualified' : 'waiting')">{{data.remarks}}</p></td>
                                  </tr>
                                </tbody>
                              </table>

                              <!-- <div class="row mt-3">
                                <p *ngIf="data.remarks === 'Selected'" style="font-size: 18px;font-weight: bold;">Admission can be taken on March 21st and 22nd between 9:00 am & 1:00 pm.</p>
                              </div> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>